import React from 'react'
import { Card, Grid, Label } from 'semantic-ui-react'
import { colorForRole, getObjectById, portraitImageUrl } from '../../utility/Global'

import tierList from '../../assets/json/tier-list.json'
import guardianIds from '../../assets/json/guardians.json'

const openGuardianDetails = (id) => {
    window.open(`/guardians/${id?.toLowerCase()}`, '_blank')
}

const guardianById = (id) => {
    return getObjectById(guardianIds, id)
}

const TierGroup = ({label, tier}) => (
    <Grid.Row>
        <Grid.Column width={1}>
        <Label className='tier-list-label' size='massive' color={tier?.color}> 
            {label?.toUpperCase()}
        </Label>
        </Grid.Column>
        <Grid.Column width={15}> 
            <Card.Group className='tier-list-group'>
                {tier?.list?.map((item, index) => {
                    const guardian = guardianById(item)
                    return <Card title={guardian?.name} 
                    key={index} 
                    className={`tier-list-card bcg-${colorForRole(guardian?.role ?? '')}`} 
                    image={portraitImageUrl(guardian?.name, 'small')}
                    onClick={(e) => {openGuardianDetails(guardian?.id)}} />
                })}
            </Card.Group>
        </Grid.Column>
    </Grid.Row>
)

export const TierList = () => (
    <Card fluid className='tier-list-container'>
        <Card.Content>
            <Grid>
                {
                    Object.entries(tierList).map(([key, value]) => {
                        return <TierGroup key={key} label={key} tier={value} />
                    })
                }
            </Grid>
        </Card.Content>
    </Card>
)